import React, { useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTheme } from "styled-components";
import { IURLTokenProps } from "../../../@interfaces";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ToastContext from "../../../contexts/toast";
import APIAuth from "../../../services/APIAuth";
import packageInfo from "../../../../package.json";
import LoginInput from "../../../components/input/loginInput";
import LoginButton from "../../../components/button/loginButton";
import Title from "../../../components/title";
import Text from "../../../components/text";

const { version } = packageInfo;

const PasswordChangeModal: React.FC = () => {
  const { userinfo } = useParams<IURLTokenProps>();
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordRep, setNewPasswordRep] = useState<string>("");
  const [verificationCode, setVerificationCode] = useState<string>();
  const [arePasswordsDifferent, setArePasswordsDifferent] = useState<boolean>();
  const { showErrorToast, showSuccessToast } = useContext(ToastContext);
  const history = useHistory();
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  const theme = useTheme()

  async function handleClick() {

    if (!newPassword || !newPasswordRep || !verificationCode) {
      showErrorToast('Preencha todos os campos');
      return;
    }

    if (newPassword !== newPasswordRep) {
      showErrorToast('Senhas divergentes.')
      setArePasswordsDifferent(true);
      return;
    }

    setArePasswordsDifferent(false);

    const body = {
      novasenha: btoa(newPassword),
      confirmacaonovasenha: btoa(newPasswordRep),
      CodigoRecuperacao: btoa(verificationCode)
    };
    const userInfo = JSON.parse(atob(userinfo));
    const user = {
      user: userInfo.email,
      pass: '',
      code: userInfo.code
    }
    const result = await APIAuth.changePassword(body, user);
    if (!result.err) {
      showSuccessToast('Senha trocada com sucesso.')
      history.push('/')
    } else {
      showErrorToast(result.message);
    }
  }




  return (
    <div className="bg-[#f4f5f9] w-screen min-h-dvh flex flex-col">
      <div className="flex flex-col items-center justify-center flex-1">
        <section className='w-screen flex justify-center items-center flex-col'>
          <Title className="!text-[2.475rem] !font-normal !text-center !text-[#002445] !mb-2 ">Troca de Senha</Title>
        </section>

        <section className="w-[400px] max-[420px]:max-w-[300px] bg-white rounded-[10px] px-[20px] py-[30px] mt-7 shadow-sm">

          <Text className="!text-[#92A1B1] text-center !text-[.85rem]">
            Informe o código recebido e crie uma nova senha
          </Text>

          <form
            className="flex flex-col gap-[20px] mt-[30px]"
            onSubmit={(e) => e.preventDefault()}
          >

            <LoginInput
              label="Código de verificação"
              placeholder="Digite o código"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              maxLength={6}
            />

            <LoginInput
              label="Nova senha"
              type="password"
              placeholder="Digite a nova senha"
              value={newPassword}
              errorMessage={arePasswordsDifferent ? "As senhas não coincidem" : undefined}
              onChange={(e) => setNewPassword(e.target.value)}
              showPasswordToggle
              isPasswordVisible={isNewPasswordVisible}
              onTogglePassword={() => setIsNewPasswordVisible(v => !v)}
            />

            <LoginInput
              label="Confirmar senha"
              type="password"
              placeholder="Repita a nova senha"
              value={newPasswordRep}
              errorMessage={arePasswordsDifferent ? "As senhas não coincidem" : undefined}
              onChange={(e) => setNewPasswordRep(e.target.value)}
              showPasswordToggle
              isPasswordVisible={isConfirmPasswordVisible}
              onTogglePassword={() => setIsConfirmPasswordVisible(v => !v)}
            />

            <LoginButton onClick={handleClick}>
              CONFIRMAR TROCA
            </LoginButton>

          </form>
        </section>
      </div>

      <div className="pb-2.5 text-center">
        <Text className="!text-[.75rem] !text-[#92A1B1]">
          Desenvolvido por Grupo HK
        </Text>
      </div>
      {/* <span className="absolute bottom-2.5 text-center self-center text-[.69rem] text-[#92A1B1] font-light">v{version}</span> */}
    </div>
  )
}

export default PasswordChangeModal;